import { Container ,Image,Card,Row,Col} from "react-bootstrap";
import {HiOutlineHandThumbUp} from 'react-icons/hi2';
import {FcTodoList,FcIdea} from 'react-icons/fc'
import './Style/Statistics.css'
function Statistics(){
    return(
        <div className="statistics d-flex align-items-center">
        <Container fluid className="d-flex justify-content-center align-items-center">
            <div className="main">
                <span className="circle1"></span>
                <span className="circle2"> </span>
            </div>
            <div className="creative-shape" >
                <Image fluid className="creative-shape-img-2" src="./imgs/creative-circle-img.png" />
            </div>
            <div className="cardsContainer">
            <Row className="cards p-5 m-sm-5 m-md-0 p-lg-5 justify-content-center">
                <Col xs="12" md="6" lg="3">
                <Card className="border-0 rounded-4" style={{backgroundColor:"#ffadad",minWidth:"260px"}}>
            <Card.Body className="d-flex align-items-center gap-3">
            <div className="fs-1 sIcon"><HiOutlineHandThumbUp/></div>
            <div>
                <span className="fs-3 fw-bold">100%</span>
                <p className="fs-4">رضا العملاء</p>
            </div>
            </Card.Body>
            </Card>
                </Col>
                <Col xs="12" md="6" lg="3">
                <Card className="border-0 rounded-4" style={{backgroundColor:"#57c9da",minWidth:"260px"}}>
            <Card.Body className="d-flex align-items-center gap-3">
            <div className="fs-1 sIcon"><FcTodoList/></div>
            <div>
                <span className="fs-3 fw-bold">257</span>
                <p className="fs-4">مشاريع مكتملة</p>
            </div>
            </Card.Body>
            </Card>
                </Col>
                <Col xs="12" md="6" lg="3">
                <Card className="border-0 rounded-4" style={{backgroundColor:"#ffdc60",minWidth:"260px"}}>
            <Card.Body className="d-flex align-items-center gap-3">
            <div className="fs-1 sIcon"><FcIdea/></div>
            <div>
                <span className="fs-3 fw-bold">لامحدودة!</span>
                <p className="fs-4">الافكار الإبداعية</p>
            </div>
            </Card.Body>
            </Card>
                </Col>
            </Row>
            </div>
        </Container>
        </div>

    )
}

export default Statistics;